import { render, staticRenderFns } from "./PhieuSuaChuaCuaHang.vue?vue&type=template&id=3d72f8c8&scoped=true&"
import script from "./PhieuSuaChuaCuaHang.vue?vue&type=script&lang=js&"
export * from "./PhieuSuaChuaCuaHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72f8c8",
  null
  
)

export default component.exports